// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export var Template_TemplateType;
(function (Template_TemplateType) {
    Template_TemplateType["DEFAULT"] = "DEFAULT";
    Template_TemplateType["CUSTOM"] = "CUSTOM";
})(Template_TemplateType || (Template_TemplateType = {}));
export var Template_TemplateType_index;
(function (Template_TemplateType_index) {
    Template_TemplateType_index[Template_TemplateType_index["DEFAULT"] = 0] = "DEFAULT";
    Template_TemplateType_index[Template_TemplateType_index["CUSTOM"] = 1] = "CUSTOM";
})(Template_TemplateType_index || (Template_TemplateType_index = {}));
export const LandingPageTemplateService = {
    /**
     * UpsertTemplate creates or updates a template.
     */
    UpsertLandingPageTemplate(fn, req) {
        return fn(`/reviews/landing-page-templates/v1/landing_page_templates`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * ListTemplatePlaceholders returns the list of placeholders that can be injected into a template.
     */
    ListTemplatePlaceholders(fn, req) {
        return fn(`/reviews/landing-page-templates/v1/landing_page_templates/placeholders?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * ListLandingPageTemplates returns a list of templates for a given locations.
     */
    ListLandingPageTemplates(fn, req) {
        return fn(`/reviews/landing-page-templates/v1/landing_page_templates?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * GetLandingPageTemplate returns a single template by ID.
     */
    GetLandingPageTemplate(fn, req) {
        try {
            fm.validateUrlParam(req["templateId"], "templateId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/reviews/landing-page-templates/v1/landing_page_templates/${req["templateId"]}?${fm.renderURLSearchParams(req, ["templateId"])}`, { method: "GET" });
    },
    /**
     * DeleteLandingPageTemplate deletes a template by ID.
     */
    DeleteLandingPageTemplate(fn, req) {
        try {
            fm.validateUrlParam(req["templateId"], "templateId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/reviews/landing-page-templates/v1/landing_page_templates/${req["templateId"]}?${fm.renderURLSearchParams(req, ["templateId"])}`, { method: "DELETE" });
    },
    /**
     * RenderLandingPageTemplate renders a review page for a location. This will return the default
     * if the location does not have a template.
     */
    RenderLandingPageTemplate(fn, req) {
        return fn(`/reviews/landing-page-templates/v1/landing_page_template:render?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * GenerateRenderLink creates a link to a review landing page.
     */
    GenerateRenderLink(fn, req) {
        try {
            fm.validateUrlParam(req["templateId"], "templateId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/reviews/landing-page-templates/v1/landing_page_template/${req["templateId"]}?${fm.renderURLSearchParams(req, ["templateId"])}`, { method: "GET" });
    },
};
